/**
 * Platform-neutral answer-reveal helpers shared by the web and native
 * SingleSelect and MultiSelect option cards.
 */

import { optionFeedbackPresentation, type SelectOption } from './SingleSelect';

/** Border colour and style for a revealed option, or nothing for a plain one. */
export function revealedBorderStyle(
  option: SelectOption,
): { borderColor: string; borderStyle: 'solid' | 'dashed' } | undefined {
  if (option.feedback === undefined) return undefined;
  const { borderColor, borderStyle } = optionFeedbackPresentation(option.feedback);
  return { borderColor, borderStyle };
}

/**
 * The accessible name of an option. A caller-supplied `accessibilityLabel` wins
 * (it is localized as a whole); otherwise a revealed option is its label then
 * its state, so a screen reader hears the result with the option it belongs to.
 */
export function optionAccessibilityLabel(option: SelectOption): string {
  if (option.accessibilityLabel !== undefined) return option.accessibilityLabel;
  return option.feedback !== undefined && option.feedbackLabel
    ? `${option.label}, ${option.feedbackLabel}`
    : option.label;
}
